export enum ExceptionsType {
  ER_DUP_ENTRY = 409
}
